import React from 'react';
import { Section } from '../ui/Section';
import { Quote } from 'lucide-react';
export function Testimonial() {
  return <Section background="offwhite" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center" data-id="element-128">
        <div className="flex justify-center mb-6" data-id="element-129">
          <Quote size={48} className="text-primary-gold" data-id="element-130" />
        </div>
        <blockquote className="text-2xl md:text-3xl font-playfair text-primary-deep-blue mb-8" data-id="element-131">
          "The supplies from Farasha Medical Aid have transformed our ability to
          serve our community. We can now provide quality care to hundreds of
          patients each month who would otherwise have no access to medical
          treatment."
        </blockquote>
        <div className="flex items-center justify-center" data-id="element-132">
          <div className="w-16 h-16 rounded-full overflow-hidden mr-4" data-id="element-133">
            <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80" alt="Dr. Mina at St. Mary's Monastery Clinic" className="w-full h-full object-cover" data-id="element-134" />
          </div>
          <div className="text-left" data-id="element-135">
            <p className="font-playfair font-bold text-primary-deep-blue" data-id="element-136">
              Dr. Mina
            </p>
            <p className="font-inter text-neutral-charcoal" data-id="element-137">
              St. Mary's Monastery Clinic, Minya
            </p>
          </div>
        </div>
      </div>
    </Section>;
}